module.exports = __webpack_public_path__ + "static/media/charlotte-regret-and-time-travel-new-cropped.82ad7e97.jpg";